import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  title: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '20px',
    color: '#676A6C',
  },
  subtitle: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '18px',
    color: '#676A6C',
  },
  searchContainer: {
    width: '60%',
    marginBottom: '1rem'
  },
  tableContainer: {
    overflowX: 'auto',
    '& table': {
      minWidth: '600px',
    }
  },
  modalFooter: {
    justifyContent: 'center !important',
  },
}));

export default useStyles;